import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/axios';
import { GET_PURCHASE_ORDER_ACTIVITY_KEY } from '@/keys';

type SendProductionDeclarationPayload = {
  recipients: string[];
  message: string;
};

export function useSendProductionDeclaration(purchaseOrderId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SendProductionDeclarationPayload) => {
      await api.post(
        `/purchase-orders/${purchaseOrderId}/production-declaration/send`,
        payload,
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [...GET_PURCHASE_ORDER_ACTIVITY_KEY, purchaseOrderId],
      });
    },
  });
}
